import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './App.css'
import Footer from './Component/Footer'
import Contact_Component from './Component/Contact_Component'
import Main_Navbar from './Component/Main_Navbar'
import About_us from './Page/About_us'
import Campus_Ambassador from './Component/Campus_Ambassador'
import Our_program from './Page/Our_program'
import BDA_job from './Component/BDA_job'
import Advance_program_page from './Page/Advance_program_page'
//import ML_page from './Component/Machine_learning/ML_page'
import WD_page from './Component/Wed_Development/WD_page'
import DS_page from './Component/Data_Science/DS_page'
import CS_page from './Component/Cyber Security/CS_page'
import AI_page from './Component/Artificial Intelligence/AI_page'
import CC_page from './Component/Cloud Computing/CC_page'
import AAD_page from './Component/Android App Development/AAD_page'
import RO_page from './Component/Robotics/RO_page'
import AC_page from './Component/AutoCAD/AC_page'
import HR_page from './Component/Human Resource/HR_page'
import FA_page from './Component/Finance/FA_page'
import BA_page from './Component/Business Analytics/BA_page'
import DM_page from './Component/Digital Marketing/DM_page'
import Java_page from './Component/Java/Java_page'
import PY_page from './Component/Python/PY_page'
import DMM_page from './Component/Digital Marketing & Marketing/DMM_page'
import FSW_page from './Component/Full Stack Web/FSW_page'
import MS_page from './Component/MS Course/MS_page'
import CCD_page from './Component/C, C++ with DSA/CCD_page'
import Main_Home_page from './Page/Main_Home_page'
import Contact_page from './Page/Contact_page'
import Student_Register_form from './Page/Student_Register_form'
import Terms_page from './Page/Terms_page'
import Not_Found from './Page/Not_Found'
import Terms_and_Conditions from './Page/Terms_and_Conditions'
import ScrollToTop from './Component/ScrollToTop'
import Mobile_program from './Component/Mobile_program'
import Mobile_career from './Component/Mobile_career'
import VLSI_page from './Component/VLSI/VLSI_page'
import IOT_page from './Component/IOT/IOT_page'
import ES_page from './Component/Embedded System/ES_page'
import CD_page from './Component/Car Designing/CD_page'
import GE_page from './Component/Genetic Engineering/GE_page'
import HEV_page from './Component/Hybrid Electric Vehicle/HEV_page'
import ICE_page from './Component/IC Engine/ICE_page'
 import MLP_page from './Component/ML With Python/MLP_page'
import NST_page from './Component/Nano Science & Nanotech/NST_page'
import P_page from './Component/Psychology/P_page'
import SCM_page from './Component/Supply Chain Management/SCM_page'
import ARVR_page from './Component/ARVR/ARVR_page'
import B_page from    './Component/Bioinformatics/B_page'
import RA_page from   './Component/Regulatory Affairs/RA_page'
import Blog_page from './Page/Blog_page'
import Blog_page_content from './Component/Blog_page_content'
import Blog_page_content1 from './Component/Blog_page_content1'
import Blog_page_content2 from './Component/Blog_page_content2'
import Blog_page_content3 from './Component/Blog_page_content3'
import Blog_page_content4 from './Component/Blog_page_content4'
import Combo_page from './Page/Combo_page'
import Coding_camp from './Component/Coding_camp'
import Ai_career_paths from './Component/Ai_career_paths'
import Data_science_career from './Component/Data_science_careers'
import Machine_learning_career from './Component/Machine-learning-careers'
import Ai_in_tech_industry from './Component/Ai_in_tech_industry'
import Internship_for_college_students from './Component/Internship_for_college_students'
import Online_internship_for_students_with_certificate from './Component/Online_internship_for_students_with_certificate'
import Html_css_page from './Component/Html_css/Html_css_page'
import Php_page from './Component/PHP/Php_page'
import Java_coding from './Component/Java Coding Camp/Java_coding'
import Python_coding from './Component/Python Coding Camp/Python_coding'
import Net_coding from './Component/Net Coding Camp/Net_coding'
import CodeEditorPage from './Page/CodeEditorPage'
import Campus_form from './Page/Campus_form'
import Coming_program from './Component/Coming_program'
import Campus_certificate from './Component/Campus_certificate'
import Boost_your_career_with_certification_course from './Component/Boost_your_career_with_certification_course'
import Devops_page from './Component/DevOps/Devops_page'
import Stock_page from './Component/Stock Market/Stock_page'
import Video_Ed_page from './Component/Video Editing/Video_Ed_page'
import UIUX_page from './Component/UIUX/UIUX_page'
import GD_page from './Component/Graphic Design/GD_page'
import LD_page from './Component/Legal Drafting/LD_page'
import Pop from '../src/Page/Pop'
import GenAi from './Component/Generative Ai/GenAi'
import CertifiacteVerify from './Component/CertifiacteVerify'
//import Festival_Page from './Component/Festival_Page'


function App() {
  return (
    <>
      <HelmetProvider>
        <Router>
          <div className="App">
            {/* <Pop /> */}
            <ScrollToTop />
            <Main_Navbar />
            <Routes>
              <Route path="/" element={<Main_Home_page />} />
              <Route path="/About-Internselite" element={<About_us />} />
              <Route path="/Blog" element={<Blog_page />} />
              <Route path="/Best-Online-Courses-Internselite" element={<Blog_page_content />}/>
              <Route path="/Online-Internship" element={<Blog_page_content1 />}/>
              <Route path="/Courses-From-IIT" element={<Blog_page_content2 />}/>
              <Route path="/Elevate-Your-Career-With-Professional-Courses" element={<Blog_page_content3 />}/>
              <Route path="/The-Power-Of-Online-Training" element={<Blog_page_content4 />}/>
              <Route path="/Ai-Career-Paths" element={<Ai_career_paths />} />
              <Route path="/Data-Science-Career" element={<Data_science_career />}/>
              <Route path="/Machine-Learning-Career" element={<Machine_learning_career />}/>
              <Route path="/Ai-in-Tech-Industry" element={<Ai_in_tech_industry />}/>
              <Route path="/Internship-for-College-Students" element={<Internship_for_college_students />}/>
              <Route path="/Online-Internship-for-Students-with-Certificate" element={<Online_internship_for_students_with_certificate />}/>
              <Route path="/Boost-Your-Career-with-Certification-Course" element={<Boost_your_career_with_certification_course />}/>
              <Route path="/Privacy-Policy/Refund-Policy" element={<Terms_page />}/>
              <Route path="/Terms-and-Conditions" element={<Terms_and_Conditions />}/>
              <Route path="/Contact-Us" element={<Contact_page />} />
              <Route path="/Traineeship-Program" element={<Our_program />} />
              <Route path="/Advance-Program" element={<Advance_program_page />}/>
              <Route path="/Up-Coming-Program" element={<Coming_program />} />
              <Route path="/Combo-Program" element={<Combo_page />} />
              <Route path="/Coding-Skill-Program" element={<Coding_camp />} />
              <Route path="/Campus-Ambassador-Program" element={<Campus_Ambassador />}/>
              <Route path="/Business-Development-Associate" element={<BDA_job />}/>
              <Route path="/Contact" element={<Contact_Component />} />
              <Route path="/Artificial-Intelligence" element={<AI_page />} />
              <Route path="/Generative-Artificial-Intelligence" element={<GenAi/>} />
              {/* <Route path="/Machine-Learning" element={<ML_page />} /> */}
              <Route path="/Web-Development" element={<WD_page />} />
              <Route path="/Data-Science" element={<DS_page />} />
              <Route path="/Android-App-Development" element={<AAD_page />} />
              <Route path="/Robotics" element={<RO_page />} />
              <Route path="/Cyber-Security" element={<CS_page />} />
              <Route path="/Cloud-Computing" element={<CC_page />} />
              <Route path="/Human-Resources" element={<HR_page />} />
              <Route path="/Finance" element={<FA_page />} />
              <Route path="/Business-Analytics" element={<BA_page />} />
              <Route path="/Autocad" element={<AC_page />} />
              <Route path="/Digital-Marketing" element={<DM_page />} />
              <Route path="/Java-Programming" element={<Java_page />} />
              <Route path="/Python-Programming" element={<PY_page />} />
              <Route path="/Digital-Marketing-and-Marketing" element={<DMM_page />}/>
              <Route path="/Full-Stack-Web-Development" element={<FSW_page />}/>
              <Route path="/Mern-Stack-Development" element={<MS_page />} />
              <Route path="/C-CPP-DSA" element={<CCD_page />} />
              <Route path="/VlSI-Design" element={<VLSI_page />} />
              <Route path="/Internet-of-Things" element={<IOT_page />} />
              <Route path="/Embedded-Systems" element={<ES_page />} />
              <Route path="/Car-Design" element={<CD_page />} />
              <Route path="/Genetic-Engineering" element={<GE_page />} />
              <Route path="/Hybrid-Electric-Vehicle" element={<HEV_page />} />
              <Route path="/IC-Engine" element={<ICE_page/>} />
              <Route path="/Machine-Learning-With-Python" element={<MLP_page/>} />
              <Route path="/Nanoscience-Nanotechnology" element={<NST_page/>} />
              <Route path="/Psychology" element={<P_page/>}/>
              <Route path="/Supply-Chain-management" element={<SCM_page/>}/>
              <Route path="/AR-VR" element={<ARVR_page/>}/>
              <Route path="/Bio-Informatics" element={<B_page/>}/>
              <Route path="/Regulatory-Affairs" element={<RA_page/>}/>
              <Route path="/Html-CSS" element={<Html_css_page />} />
              <Route path="/PHP-Course" element={<Php_page />} />
              <Route path="/Java-Coding-Camp-Course" element={<Java_coding />}/>
              <Route path="/Python-Coding-Camp-Course" element={<Python_coding />}/>
              <Route path="/.Net-Coding-Camp-Course" element={<Net_coding />} />
              <Route path="/DevOps-Course" element={<Devops_page />} />
              <Route path="/Stock-Market" element={<Stock_page />} />
              <Route path="/Video-Editing-Course" element={<Video_Ed_page />} />
              <Route path="/UI-UX-Design" element={<UIUX_page />} />
              <Route path="/Graphic-Design" element={<GD_page />} />
              <Route path="/Legal-Drafting-Course" element={<LD_page />} />
              <Route path="/Student-Register" element={<Student_Register_form />}/>
              <Route path="/Training-Programs" element={<Mobile_program />} />
              <Route path="/Careers" element={<Mobile_career />} />
              <Route path="/Code-Editor-Page" element={<CodeEditorPage />} />
              <Route path="*" element={<Not_Found />} />
              <Route path="/Campus-Ambassadar-form" element={<Campus_form />} />
              <Route path="/Campus-Ambassadar-Certificat" element={<Campus_certificate />}/>
              <Route path="/Certificate-Verify" element={<CertifiacteVerify/>}/>
               <Route path="/Internet-Of-Things" element={<IOT_page/>}/>
               {/* <Route path="/Festival-Offer" element={<Festival_Page/>}/> */}
              
              {/* <Route path='/3Days-Pan-India-IT-Bootcamp' element={<Bootcamp/>}/> */}
            </Routes>
            <Footer />
          </div>
        </Router>
      </HelmetProvider>
    </>
  )
}
export default App
